import {NgModule} from '@angular/core';
import {Routes, RouterModule, Router, NavigationStart} from '@angular/router';

import {DashboardComponent} from './dashboard/dashboard.component';
import {ProfileComponent} from './profile/profile.component';
import {HouseholdComponent} from './household/household.component';
import {AccountComponent} from './account/account.component';
import {SettingsComponent} from './settings/settings.component';
import {ContactComponent} from './contact/contact.component';
import {ImprintComponent} from './imprint/imprint.component';
import {PrivacyComponent} from './privacy/privacy.component';
import {LoginComponent} from './login/login.component';
import {RegisterComponent} from './register/register.component';
import {ForgotComponent} from './forgot/forgot.component';

import {Angulartics2} from 'angulartics2';
import {AuthGuardService} from './services/auth-guard.service';

const routes: Routes = [
    {
        path: '',
        component: DashboardComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'meine-daten',
        component: ProfileComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'mein-haushalt',
        component: HouseholdComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'mein-kundenkonto',
        component: AccountComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'einstellungen',
        component: SettingsComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'kontakt',
        component: ContactComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'impressum',
        component: ImprintComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'datenschutz',
        component: PrivacyComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'registrieren',
        component: RegisterComponent
    },
    {
        path: 'passwort-vergessen',
        component: ForgotComponent
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {useHash: true}),
    ],
    exports: [
        RouterModule,
    ]
})

export class AppRoutingModule {

    previous_page: string = null;

    constructor(private _router: Router,
                private _analytics: Angulartics2) {

        this._router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.trackPage(event.url, this.previous_page);

                this.previous_page = event.url;
            }
        });

    }

    /**
     * Google Analytics Track Page Event
     *
     * @param page
     * @param previous_page
     */
    trackPage(page: string, previous_page: string) {
        this._analytics.eventTrack.next({
            action: 'screen_view',
            properties: {
                category: 'Screens',
                label: 'screen: ' + this.getPageByRoute(page) + '; previous_screen: ' + this.getPageByRoute(previous_page)
            }
        });
    }

    /**
     * Seiten-Name anhand der Route identifizieren (Für Google Analytics)
     *
     * @param page
     */
    getPageByRoute(page: string) {
        switch (page) {
            case '/':
                return 'Übersicht';
            case '/meine-daten':
                return 'Meine Daten';
            case '/mein-haushalt':
                return 'Mein Haushalt';
            case '/mein-kundenkonto':
                return 'Mein Kundenkonto';
            case '/einstellungen':
                return 'Einstellungen';
            case '/kontakt':
                return 'Kontakt';
            case '/impressum':
                return 'Impressum';
            case '/datenschutz':
                return 'Datenschutz';
            case '/login':
                return 'Login';
            case '/registrieren':
                return 'Registrieren';
            case '/passwort-vergessen':
                return 'Passwort vergessen';
            default:
                return 'Unbekannt';
        }
    }

}

export const routedComponents: any[] = [
    DashboardComponent,
    ProfileComponent,
    HouseholdComponent,
    AccountComponent,
    SettingsComponent,
    ContactComponent,
    ImprintComponent,
    PrivacyComponent,
    LoginComponent,
    RegisterComponent,
    ForgotComponent
];
